export default __webpack_public_path__ + "static/media/paypal.ff323c2a.png";